<template>
  <div class="edit-proxy-wrap">
    <div class="ep-header">
      <div class="ep-info-row">
        <div class="ep-info-item">
          <span class="ep-label">{{ $t('msg.User_Name2') }}</span>
          <span class="ep-badge ep-badge--green" translate="no">{{ proxyUsername }}</span>
        </div>
        <div class="ep-info-item" v-if="up_username">
          <span class="ep-label">{{ $t('msg.User_agent') }}</span>
          <span class="ep-badge ep-badge--gray" translate="no">{{ up_username }}</span>
        </div>
      </div>
    </div>

    <el-form :model="proxyInfo" :rules="userRules" ref="user" label-width="90px" class="ep-form">
      <el-form-item :label="$t('msg.Password2')" prop="password">
        <el-input v-model="proxyInfo.password" @focus="clearDefault" @blur="addDefaule" autocomplete="off" style="width:260px;"></el-input>
      </el-form-item>
      <el-form-item :label="$t('msg.Name2')">
        <el-input v-model="proxyInfo.realname" autocomplete="off" style="width:260px;"></el-input>
      </el-form-item>
      <el-form-item :label="$t('msg.Tel')">
        <el-input v-model="proxyInfo.pnum" autocomplete="off" style="width:260px;"></el-input>
      </el-form-item>
      <el-form-item :label="$t('msg.Description1')">
        <el-input v-model="proxyInfo.description" type="textarea" :rows="3" resize="vertical" style="width:260px;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="updateProxy">{{ $t('msg.OK1') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {GetProxyInfo, UpdateProxyInfo} from "../api";
var LxStr = function(str){
  if(str){
    var arr = str.split('');
    var flag = true;
    for (var i = 1; i < arr.length-1; i++) {
      var firstIndex = arr[i-1].charCodeAt();
      var secondIndex = arr[i].charCodeAt();
      var thirdIndex = arr[i+1].charCodeAt();
      // thirdIndex - secondIndex == 1;
      // secondIndex - firstIndex==1;
      if((thirdIndex - secondIndex == 1)&&(secondIndex - firstIndex==1)){
        flag =  false;
      }
    }
    return flag;
  }
}
export default {
  name: "EditProxy",
  data() {
    return {
      proxyUsername: '',
      up_username: '',
      proxyInfo: {realname: '', pnum: '', description: '', password: "******"},
      userRules: {
        password: [
          {required: true, message: this.$t('msg.Please_enter_your_password'), trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              if (value === "******") {
                  callback();
              }
              else if (value.length < 6 || value.length > 15) {
                callback(new Error(this.$t('msg.Password_format_hint')));
              } else if (value.search(/\d/) == -1) {
                callback(new Error(this.$t('msg.Password_format_hint')));
              } else if (value.search(/[a-zA-Z]/) == -1) {
                callback(new Error(this.$t('msg.Password_format_hint')));
              } else if (value.search(/[^a-zA-Z0-9\!\_-]/) != -1) {
                callback(new Error(this.$t('msg.Password_format_hint')));
              }
              else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
      },
    }
  },
  methods: {
    getProxyData() {
      GetProxyInfo({"search_username": this.proxyUsername}).then((data) => {
        if (data.data.errcode === 0 && data.data.params.status === 0) {
          this.proxyInfo.realname = data.data.params.data.realname
          this.proxyInfo.pnum = data.data.params.data.pnum
          this.proxyInfo.description = data.data.params.data.description
          this.up_username = data.data.params.data.up_username
        } else {
          msg = data.data.params.msg
          if (!data.data.params.msg) {
            var msg = this.$t('msg.Failed_to_obtain_data')
          }
          this.$message({
            message: msg,
            type: 'error',
            offset: 80
          });
        }
      })
    },
    updateProxy() {
      var val = true
      var from = 'user'
      this.$refs[from].validate(valid => {
        if (!valid) {
          // 表单验证失败，显示错误消息...
          val = false
        }
      })
      //添加代理
      if (val) {
        var params = {}
        if (this.proxyInfo.password !== "******") {
          params["password"] = this.proxyInfo.password
        }
        params["search_username"] = this.proxyUsername
        params["realname"] = this.proxyInfo.realname
        params["pnum"] = this.proxyInfo.pnum
        params["description"] = this.proxyInfo.description
        UpdateProxyInfo(params).then((data) => {
          if (data.data.errcode === 0 && data.data.params.status === 0) {
            this.$message({
              message: this.$t('msg.Successful_operation'),
              type: 'success',
              offset: 80
            });

          } else {
            msg = data.data.params.msg
            if (!data.data.params.msg) {
              var msg = this.$t('msg.Failed_to_obtain_data')
            }
            this.$message({
              message: msg,
              type: 'error',
              offset: 80
            });
          }
        })
      }
    },
    clearDefault(){
      if(this.proxyInfo.password === "******"){
        this.proxyInfo.password = ""
      }
    },
    addDefaule(){
      if(this.proxyInfo.password === ""){
        this.proxyInfo.password = "******"
      }
    }
  },
  mounted() {
    this.proxyUsername = this.$route.query.proxyName
    this.getProxyData()
  }
}
</script>

<style lang="less" scoped>
.edit-proxy-wrap {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .08);
  padding: 24px;
  max-width: 480px;
}

.ep-header {
  padding-bottom: 16px;
  margin-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
}

.ep-info-row {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.ep-info-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ep-label {
  color: #909399;
  font-size: 13px;
}

.ep-badge {
  border-radius: 4px;
  padding: 3px 12px;
  font-size: 14px;
  font-weight: 700;

  &--green {
    background: #f0faf4;
    color: #27ae60;
    border: 1px solid #b7e4c7;
  }

  &--gray {
    background: #f4f4f5;
    color: #606266;
    border: 1px solid #dcdfe6;
  }
}

.ep-form {
  .el-form-item {
    margin-bottom: 16px;
  }
  .el-form-item:last-child {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/EditProxy.vue